export const getStrokDashArray = (type) => {
  if (type === 'dashed') {
    return '10,10';
  }
  if (type === 'dotted') {
    return '2,4';
  }
  return '';
};
